<app-habitation-page-container>
  <div class="page-content">
    <h1 appFocusOnInit class="sr-only" [innerText]="'breadcrumb.propriete.liste' | translate"></h1>
    <div class="contenu">
      <img src="{{ 'assets/images/money-bag-dollar.svg' | cheminAbsoluStatique }}" alt="" class="contenu-img" />
      <p class="contenu-texte" [innerHTML]="textContent | translate"></p>
    </div>
    <button id="calculer-ma-capacite" class=" bouton green" mat-button (click)="navigateTo('/capacite')">
      {{ 'introduction.bouton' | translate }}
    </button>

    <button mat-button class=" no-border no-margin" id="btn-rtn-accueil" (click)="navigateTo('')">
      <img src="{{ 'assets/images/arrow/green-left.svg' | cheminAbsoluStatique }}" alt="" class="button-icone-left" />
      <strong>{{ 'btn.retour-accueil' | translate }}</strong>
    </button>
  </div>
</app-habitation-page-container>
<app-sub-footer class="sub-footer" [enableNextStep]="true" [nextStep]="'preauth'"></app-sub-footer>
